import { render } from "./ViewerBottomSheet.vue?vue&type=template&id=3ad44062&scoped=true&ts=true"
import script from "./ViewerBottomSheet.vue?vue&type=script&lang=ts"
export * from "./ViewerBottomSheet.vue?vue&type=script&lang=ts"

import "./ViewerBottomSheet.vue?vue&type=style&index=0&id=3ad44062&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad44062"]])

export default __exports__